export const CNC_DONE_REQUEST = "CNC_DONE_REQUEST";
export const CNC_DONE_SUCCESS = "CNC_DONE_SUCCESS";
export const CNC_DONE_FAILED = "CNC_DONE_FAILED";